module.exports = __webpack_public_path__ + "img/preview.fefd4a23.jpg";